import { ContextManager } from "~/modules/contextManager/ContextManager";
import { validateToken } from "./ValidateToken";

export const validateTokenWrapper = async (accountSid: string, token: string) => {
    return validateToken(ContextManager.newInstance())(accountSid, token);
};
